import { Brain, Network, Cpu } from "lucide-react";
import { Reveal, RevealStagger, staggerItem } from "@/components/site/Reveal";
import { motion } from "framer-motion";

const CARDS = [
  {
    icon: Brain,
    title: "Intelligence",
    body: "Turning information into decisions.",
  },
  {
    icon: Network,
    title: "Coordination",
    body: "Connecting people, organizations and technology.",
  },
  {
    icon: Cpu,
    title: "Automation",
    body: "Reducing complexity through intelligent software.",
  },
];

export function Company() {
  return (
    <section
      id="company"
      className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36"
      data-testid="company-section"
    >
      <Reveal>
        <p className="font-mono text-xs text-white/40">01 // COMPANY</p>
      </Reveal>
      <div className="mt-6 grid gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <h2 className="font-display text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
            Engineering Systems For High-Stakes Decisions
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5 lg:pt-3">
          <p className="font-body text-lg leading-relaxed text-white/60">
            At Cogentis Technologies we build intelligent platforms that replace
            fragmented workflows with connected systems. Our mission is to
            engineer certainty where accuracy, speed and trust matter most.
          </p>
        </Reveal>
      </div>

      <RevealStagger className="mt-16 grid gap-6 md:grid-cols-3">
        {CARDS.map((c) => (
          <motion.div
            key={c.title}
            variants={staggerItem}
            className="group glass relative overflow-hidden rounded-2xl p-8 transition-colors duration-300 hover:border-white/20"
            data-testid={`company-card-${c.title.toLowerCase()}`}
          >
            <div
              className="absolute -right-16 -top-16 h-40 w-40 rounded-full opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-40"
              style={{ background: "var(--accent)" }}
            />
            <div
              className="relative flex h-12 w-12 items-center justify-center rounded-xl border border-white/10"
              style={{ background: "rgba(255,255,255,0.03)" }}
            >
              <c.icon className="h-6 w-6" style={{ color: "var(--accent)" }} />
            </div>
            <h3 className="font-display relative mt-6 text-2xl font-medium text-white">
              {c.title}
            </h3>
            <p className="font-body relative mt-3 text-white/55">{c.body}</p>
          </motion.div>
        ))}
      </RevealStagger>
    </section>
  );
}
